'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _Input = require('../common-formsy/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Form = require('../common-formsy/Form');

var _Form2 = _interopRequireDefault(_Form);

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DEBOUNCE_DELAY = _constants.AppConstants.DEBOUNCE_DELAY;

var ListSearchFilter = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(ListSearchFilter, _Component);

  function ListSearchFilter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ListSearchFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ListSearchFilter.__proto__ || Object.getPrototypeOf(ListSearchFilter)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'searchValue', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ListSearchFilter, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          onInputChange = _props.onInputChange,
          pageStore = _props.pageStore;


      this.searchValue = pageStore.filters.search || '';

      // this is tested, but the debounce is nor allowing codecov to recognize that it's covered
      /* istanbul ignore next */
      this.debouncedOnInputChange = (0, _debounce3.default)(function (search) {
        pageStore.filters.search = search;
        pageStore.ordering = []; // reset ordering so results come back sorted by similarity score
        onInputChange();
      }, DEBOUNCE_DELAY);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Form2.default,
        null,
        _react2.default.createElement(_Input2.default, { name: 'list-search-filter', onChange: this.debouncedOnInputChange, value: this.searchValue })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ListSearchFilter;
}(_react.Component), _class3.propTypes = {
  onInputChange: _propTypes2.default.func.isRequired,
  pageStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'searchValue', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
})), _class2)) || _class) || _class;

var _default = ListSearchFilter;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DEBOUNCE_DELAY, 'DEBOUNCE_DELAY', '/app/src/components/common/ListSearchFilter.js');
  reactHotLoader.register(ListSearchFilter, 'ListSearchFilter', '/app/src/components/common/ListSearchFilter.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common/ListSearchFilter.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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